var _defs, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _polygon2, _polygon3, _polygon4, _path9, _path10, _polygon5, _path11, _path12, _path13, _polygon6, _path14, _polygon7, _path15, _polygon8, _polygon9, _path16, _path17, _polygon10, _path18, _path19, _path20, _polygon11, _path21, _polygon12, _path22, _path23, _path24, _path25, _path26, _polygon13, _path27, _path28, _text, _text2, _text3, _text4, _path29, _path30, _text5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.77 190.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbcc0f;}.cls-2{stroke:#1b110b;stroke-miterlimit:10;}.cls-3{fill:#fccc00;}.cls-4{fill:#fbcc0a;}.cls-5{fill:#fbcd13;}.cls-6{fill:none;}.cls-7{font-size:41px;}.cls-7,.cls-8{fill:#fff;font-family:Arial-Black, Arial Black;font-weight:800;}.cls-8{font-size:26px;letter-spacing:0.07em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.75,385a92.41,92.41,0,0,1-62,87.29,90,90,0,0,1-10,2.84h0a86.68,86.68,0,0,1-9.86,1.66,90.75,90.75,0,0,1-10.48.6h0a92,92,0,0,1-10.42-.59A89.27,89.27,0,0,1,274.66,475a90.9,90.9,0,0,1-10-2.9,92.24,92.24,0,0,1-34.4-21.6,90.42,90.42,0,0,1-7-7.78,92.89,92.89,0,0,1-5.59-7.75,89.45,89.45,0,0,1-5.38-9.56,88.24,88.24,0,0,1-3.93-9.27h0A92.5,92.5,0,0,1,203,385.79c0-.28,0-.55,0-.83a92.39,92.39,0,0,1,184.77,0Z",
    transform: "translate(-202.98 -287.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.43,333.15s62.62-19,145.43,1l-13.1,7.3,29.75,5.73V311.45l-17-2.86.22-10.8s-66.51-18.32-145.33,0V308l-17.15,3.28v35.86l30.46-5.57Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "60.3 133.57 53.94 133.08 53.94 135.93 53.62 138.38 52.39 139.69 51.41 140.42 45.05 140.42 39.83 140.42 36.73 138.62 34.45 136.34 31.67 129.65 29.55 121 28 113.66 27.35 106.89 27.35 98.82 28.25 93.76 30.61 90.17 34.28 86.91 38.36 84.62 42.6 83.16 43.83 82.75 43.83 81.12 42.28 79.89 39.59 79.89 37.79 79.89 35.59 79.4 32.98 77.2 31.84 75.49 32.65 73.37 33.63 71.82 38.85 71.82 40.16 71.82 42.44 72.88 43.42 74.18 43.42 76.71 43.42 77.77 45.54 79.16 54.1 68.06 58.43 63.09 61.45 60.4 64.47 58.36 67.56 57.95 74.33 57.95 75.07 57.3 75.07 53.87 77.68 49.63 80.05 47.92 82.49 46.77 93.26 46.77 99.54 46.77 102.23 47.18 104.03 47.67 106.64 49.55 107.78 51.42 108.76 53.63 109.57 57.38 116.92 57.95 120.5 58.44 123.52 59.85 127.52 63.82 130.29 67.09 136.74 76.39 138.86 79 140.65 78.18 140.65 74.75 141.63 72.47 143.59 71.49 147.5 71.41 150.36 71.9 152.24 73.28 152.97 75.57 151.66 77.44 150.2 78.75 148.48 79.48 145.63 79.73 142.94 79.73 141.31 80.22 140.57 80.87 141.63 83.07 145.14 83.89 150.03 86.66 152.97 89.19 154.03 90.74 155.34 92.86 156.31 94.98 156.72 99.88 156.72 102.81 156.72 110.32 155.58 116.93 153.87 124.76 151.34 132.83 149.87 136.5 147.18 139.36 145.38 140.42 142.12 140.75 136.33 140.75 133.39 140.75 131.6 139.93 129.8 137.89 129.72 133.97 129.72 133.24 124.67 133.4 115.69 133.57 106.56 134.06 96.2 134.22 87.79 134.22 77.19 133.65 64.55 133.73 60.3 133.57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.19,405.75H286.63l-7-.46H275s-3.69,0-4.5,3,3.23,4.51,3.23,4.51l5.78.58h35.35s5.08.23,5.31-4.05-6.58-4-6.58-4l-3.43.31Z",
    transform: "translate(-202.98 -287.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.56,383.34s28.71,12.78,68,.66C328.54,384,306.43,386.16,260.56,383.34Z",
    transform: "translate(-202.98 -287.3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M254.66,406l-4.18-.41-3.83.21s-1.92,1.8.89,3a19.21,19.21,0,0,0,3.07,1.2h4l.41-.66.17-1.54v-1.23Z",
    transform: "translate(-202.98 -287.3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M335.43,406l4.19-.41,3.83.21s1.92,1.8-.89,3a19.84,19.84,0,0,1-3.07,1.2h-4.06l-.4-.66-.17-1.54v-1.23Z",
    transform: "translate(-202.98 -287.3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.72,366.77l16.53-.32,20.41-.37,20.2.34,15,.19h7.5l3.83.16s-6-13.65-19-17.16-12.44-3-12.44-3-15.39-1.32-24.93.38-14,4.44-14,4.44-5.27,2.25-7.52,7.06A34,34,0,0,1,253.72,366.77Z",
    transform: "translate(-202.98 -287.3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M315,366.77s.58-3.42,5.25-3,4.77,3,4.77,3h4.2s-1.89-5.88-9.24-5.72-8.13,5-8.13,5l-.21.69Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "82.32 48.37 79.55 51.99 84.15 51.99 84.75 51.99 83.27 55.87 89.17 55.87 90.12 51.53 95.23 51.65 95.45 55.87 101.54 55.87 100.22 51.7 104.68 51.76 102.08 48.37 98.31 48.16 99.85 51.53 95.11 51.31 94.34 47.82 90.52 47.82 89.29 51.28 85.06 51.36 86.89 48.11 82.32 48.37"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.25 57.43 24.59 56.16 20.65 63.55 14.83 60.28 17.25 57.43"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "9.31 58.88 14.83 60.28 11.37 67.74 10.58 69.68 5.02 67.54 6.62 63.24 8.59 58.7 9.31 58.88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.38,365.9l2.18-8.92,6.67,1.76s-2.73,4.79-2.73,9Z",
    transform: "translate(-202.98 -287.3)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.18,364.83l6.2,1.07a36.58,36.58,0,0,0-1.46,9.82l-6.44-.41S204.51,367.63,205.18,364.83Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.94 88.42 12.83 88.66 12.83 98.48 5.85 98.24 6.94 88.42"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M209.62,395.07l-6,.93a88.27,88.27,0,0,1-.65-10.21l5.84-.24Z",
    transform: "translate(-202.98 -287.3)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211,404.53l-1.33-9.46,6.19-.79s.12,5.33,1.88,9C217.69,403.25,212.77,403.5,211,404.53Z",
    transform: "translate(-202.98 -287.3)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.17,413.74s-5.65,1.36-5.79,2.41a88.2,88.2,0,0,1-3-10.25l5.58-1.37S212.77,413.2,214.17,413.74Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.41 132.44 16.52 124.2 11.19 126.44 14.71 135.41 20.41 132.44"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.48,431.21,217.69,435a89.45,89.45,0,0,1-5.38-9.56l5.38-2.71Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.23 140.21 19.5 143.9 25.02 151.42 29.93 147.42 24.23 140.21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24,447.28l-4,3.24a90.42,90.42,0,0,1-7-7.78l4.71-4,4.92,6.12Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.53 57.4 160.19 56.13 164.13 63.53 169.95 60.25 167.53 57.4"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.47 58.86 169.95 60.25 173.41 67.71 174.2 69.65 179.76 67.52 178.16 63.22 176.19 58.68 175.47 58.86"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M379.36,365.87,377.18,357l-6.67,1.76s2.73,4.79,2.73,9Z",
    transform: "translate(-202.98 -287.3)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M385.56,364.8l-6.2,1.07a36.6,36.6,0,0,1,1.46,9.83l6.44-.42S386.23,367.61,385.56,364.8Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.84 88.39 171.95 88.63 171.95 98.46 178.93 98.22 177.84 88.39"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M381.12,395l6,.93a88.27,88.27,0,0,0,.65-10.21l-5.84-.24Z",
    transform: "translate(-202.98 -287.3)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M379.79,404.5l1.33-9.46-6.19-.79s-.12,5.34-1.88,9C373.05,403.23,378,403.47,379.79,404.5Z",
    transform: "translate(-202.98 -287.3)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M376.57,413.71s5.65,1.36,5.79,2.41a88.2,88.2,0,0,0,3-10.25l-5.58-1.37S378,413.17,376.57,413.71Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.37 132.42 168.25 124.17 173.59 126.41 170.07 135.39 164.37 132.42"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M368.26,431.18l4.79,3.78a89.45,89.45,0,0,0,5.38-9.56l-5.38-2.71Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.55 140.18 165.28 143.88 159.76 151.4 154.85 147.4 160.55 140.18"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M356.5,447.25l4,3.24a90.42,90.42,0,0,0,7-7.78l-4.71-4-4.92,6.12Z",
    transform: "translate(-202.98 -287.3)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M232.21,468.66l.7-33.93s59.6-6.47,124.47,0v33.93Z",
    transform: "translate(-202.98 -287.3)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M264.67,472.12l-.33.71L254.81,468A91.94,91.94,0,0,0,264.67,472.12Z",
    transform: "translate(-202.98 -287.3)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M266.72,467.62l-2.05,4.5a91.94,91.94,0,0,1-9.86-4.13Z",
    transform: "translate(-202.98 -287.3)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M285.35,471.12l-.41,5.64A89.27,89.27,0,0,1,274.66,475l1.52-5.39Z",
    transform: "translate(-202.98 -287.3)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "82.89 180.31 82.37 183.81 92.39 184.11 92.39 180.69 82.89 180.31"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M305.85,476.75a90.75,90.75,0,0,1-10.48.6h0v-5.93l9.43-.45Z",
    transform: "translate(-202.98 -287.3)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M325.71,472.25a90,90,0,0,1-10,2.84h0l-1.09-6.43L304.79,471l-.52-3.35,18.17-1.19Z",
    transform: "translate(-202.98 -287.3)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(35.27 39.2) rotate(-7.52)"
  }, "T")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(63.84 35.45) rotate(-0.84)"
  }, "A")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "matrix(1, 0.08, -0.08, 1, 97.89, 35.12)"
  }, "X")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "matrix(0.99, 0.13, -0.13, 0.99, 132.03, 38.1)"
  }, "I")), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333,394.28s-.49-8.8,9.1-13.55c0,0,10.15-2.11,12.71-.24,0,0,2.14,5.18-4.76,7.46C350.08,388,336.94,391.33,333,394.28Z",
    transform: "translate(-202.98 -287.3)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.07,394.28s.49-8.8-9.1-13.55c0,0-10.15-2.11-12.71-.24,0,0-2.14,5.18,4.76,7.46C240,388,253.16,391.33,257.07,394.28Z",
    transform: "translate(-202.98 -287.3)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(37.65 172.97)"
  }, "TESLIC")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiLogo);
export default __webpack_public_path__ + "static/media/taxi-logo.1a26e785df68de0b1ca427159c3b16cf.svg";
export { ForwardRef as ReactComponent };